module.exports = __webpack_public_path__ + "img/icon-fom-personal-form.dafcaa73.png";